import { atom } from 'jotai';

/** Every section of the Templates page arrives folded, so the page opens on its list of sections. */
const COLLAPSED_ON_ARRIVAL = true;

export const is360CollapsedAtom = atom(COLLAPSED_ON_ARRIVAL);
export const isSelfCollapsedAtom = atom(COLLAPSED_ON_ARRIVAL);
export const isManagerCollapsedAtom = atom(COLLAPSED_ON_ARRIVAL);
export const isMeetingPlanCollapsedAtom = atom(COLLAPSED_ON_ARRIVAL);
